import { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { buttonLegacyDefaultV0Schema } from './default';
import { buttonLegacyZeroV0Schema } from './zero';

/**
 * Discriminated union over the envelope's `type` field. Persisted entities
 * without a `type` field land on the default branch (its `type` literal is
 * `.optional()`); entities tagged `type: 'zero'` land on the zero branch.
 *
 * Unlike video, the two button variants also diverge on the inner data
 * shape: the default branch carries the simple `position` grid (nullish),
 * the zero branch requires the extended-position grid.
 */
const buttonLegacyEntityUnion = z.discriminatedUnion('type', [buttonLegacyDefaultV0Schema, buttonLegacyZeroV0Schema]);

export type LegacyButtonDefault = z.infer<typeof buttonLegacyDefaultV0Schema>;
export type LegacyButtonZero = z.infer<typeof buttonLegacyZeroV0Schema>;
export type LegacyButton = LegacyButtonDefault | LegacyButtonZero;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet).
 * Single 'web' variant today; the mini-landing shape becomes a second variant when
 * the widget is unified across apps. When a redesigned `default/v0` lands, this
 * switches to a versioned schema and the variants gain `up` migrations into it.
 */
export const LegacyButtonEntitySchema = createLegacyEntitySchema([{ name: 'web', schema: buttonLegacyEntityUnion }]);
